import * as React from 'react';
import MyTypes from 'MyTypes';
import { bindActionCreators, Dispatch } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { Card, Spinner, Table } from 'react-bootstrap'; 
import loginStatusIcon from '../../assets/images/deployed-green.svg';
import downloadIcon from '../../assets/images/Blue/download.svg';
import * as models from '../../models';
import editIcon from '../../assets/images/Blue/edit.svg'; 
import SingleActionButton from 'components/common/SingleActionButton';
import * as router from '../../services/router-service'; 
import dateFormat from 'dateformat';
import { contactsActions } from 'store/contacts';
import { contact } from 'services/api-service';

interface Props extends PropsFromRedux {
}

interface State {    
}

class ContactsTable extends React.Component<Props, State> {
    public state = {        
    };    

    public editContact = (contactId: number) => {
        router.goto(router.url.contactDetail.replace(":contactId", contactId.toString())); 
    }

    public exportContacts = async () => {
        const exportQuery: models.ContactsRequest = {
            ...this.props.contactsRequest,
            pageNo: 1,
            pageSize: this.props.contactListResponse.totalCount,
        }
        await this.props.requestContactsCSV(exportQuery); 
    }

    public render() {
        const { contactListResponse, isContactsDownloading, isLoading } = this.props;        
        const runSpinner = isContactsDownloading || isLoading;

        return (
            <Card className="claim-card">
                <Card.Title>Contacts
                    {runSpinner && <span>&nbsp;{isContactsDownloading ? "Exporting..." : "Loading..."}&nbsp;&nbsp;<Spinner animation="border" role="status" variant="primary" size="sm"/></span>}
                    <SingleActionButton
                            action="Export"
                            title="Contacts"
                            img={downloadIcon}
                            onClick={this.exportContacts}
                            disabled={isContactsDownloading}
                        />
                </Card.Title>
            {contactListResponse.totalCount > 0 &&
                <Table striped>
                    <thead>
                        <tr>                                                    
                            <th>Login Status</th>
                            <th>Active</th> 
                            <th>Full Name</th>                                                        
                            <th>Company Name</th>
                            <th>Email</th>
                            <th>Compass Email</th>
                            <th>XN Address</th>
                            <th>Last Activity Date</th>
                            <th>Created Date</th>                              
                        </tr>
                    </thead>
                    <tbody>
                    {contactListResponse.resourceList.map((x: models.ContactSimple, i: number) => (
                        <tr key={i}>             
                            <td>
                                {x.isLoginActive !== null && (
                                    <img 
                                        src={loginStatusIcon} 
                                        alt={x.isLoginActive ? "Active" : "Inactive"}
                                        title={x.isLoginActive ? "Login Active" : "Login Inactive"} 
                                        style={{ 
                                            width: '18px', 
                                            height: '18px',
                                            filter: x.isLoginActive ? 'none' : 'hue-rotate(240deg) saturate(150%)' 
                                        }} 
                                    />
                                )}
                            </td>
                            <td>{x.isActive ? "Yes" : "No"}</td>
                            <td>{x.fullName}</td>
                            <td>{x.companyName}</td>
                            <td>{x.email}</td>
                            <td>{x.email}</td>
                            <td>{x.xnAddress}</td>              
                            <td>{x.lastActivityDate ? dateFormat(x.lastActivityDate, "mm/dd/yyyy") : ""}</td>
                            <td>{x.createdDate ? dateFormat(x.createdDate, "mm/dd/yyyy") : ""}</td>              
                            <td>
                                <SingleActionButton
                                    action="Edit"
                                    title={"Contact"}
                                    img={editIcon}
                                    onClick={() => this.editContact(x.id)}
                                />
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            }
            </Card>
        );
    }
}
const mapStateToProps = (state: MyTypes.RootState) => ({
    contactListResponse: state.contacts.search.contactListResponse,
    contactsRequest: state.contacts.search.contactListRequest,
    isLoading: state.contacts.search.isContactListLoading,
    isContactsDownloading: state.contacts.search.isContactsDownloading,    
}); 

const mapDispatchToProps = (dispatch: Dispatch) => 
    bindActionCreators(
        {        
            requestContactsCSV: contactsActions.requestContactsCSV
        },
        dispatch
    );

const connector = connect(mapStateToProps, mapDispatchToProps); 
type PropsFromRedux = ConnectedProps<typeof connector>

export default connector(ContactsTable); 
